import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/common.css'
import Tip from '@/components/Tip'
import Confirm from '@/components/Confirm/index';
// 引入 vue-awesome-swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'

// 引入 vue-awesome-swiper 样式
import 'swiper/dist/css/swiper.css'

import api from '@/utils/api'
import VueClipBoard from 'vue-clipboard2'

Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)

Vue.use(VueClipBoard);

Vue.use(ElementUI)

Vue.prototype.$tip = Tip.install;
Vue.prototype.$api = api;
Vue.prototype.$myConfirm = Confirm.install;
// 用户信息
let user = null;
// 获取token
let token = api.getAuthToken();

Vue.prototype.$getUser = async (device, thirdToken) => {
    if (user) {
        Vue.events.trigger('USER-INFO', user);
        return user;
    }
    if (thirdToken) token = thirdToken;
    api.post('/auth/signInWithToken', { device, token }).then((res) => {
        user = res;
        Vue.closeIframe();
        if (token != res.token) api.setAuthToken(res.token);
        Vue.events.trigger('USER-INFO', user);
        return user;
    }).catch((res) => {
        user = null;
        Vue.closeIframe();
        api.reAuthToken();
        Vue.events.trigger('USER-INFO', user);
        Vue.prototype.$tip((res && res.message) || '登录失败，请重新登录');
        return user;
    });
};
Vue.prototype.$setUser = (u) => {
    if (!user) {
        user = u;
    } else if (u) {
        user = Object.assign({}, user, u);
    } else {
        user = null;
        api.reAuthToken();
    }
    Vue.events.trigger('USER-INFO', user);
};
Vue.prototype.$waitingAnticheck = () => {
    Vue.events.trigger('WAITING-ANTICHECK');
};

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
